/**
 * AnalyticsModuleFrame — the honest "detail to follow" placeholder for the A3
 * modules not yet built (drivers, site benchmarking, contribution). Names the
 * module, what it will answer, its data gate where one applies, and the windowed
 * scope it will read. Never a fake-complete screen — the frame says detail follows.
 */

import React from 'react'
import { type Scope } from '../hooks/useScope'
import { type AnalyticsModule } from '../hooks/useAnalyticsView'

export default function AnalyticsModuleFrame({
  module,
  scope,
}: {
  module: AnalyticsModule
  scope: Scope
}): React.JSX.Element {
  return (
    <div className="cx-fade border border-line rounded-xl bg-panel px-5 py-6 space-y-3">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-dashed border-line font-mono text-[10.5px] tracking-[.08em] uppercase text-mut2">
        framed · detail to follow
      </div>
      <h3 className="text-[17px] font-bold tracking-[-.01em] text-ink">{module.label}</h3>
      <p className="text-[13.5px] text-mut leading-[1.55] max-w-[660px]">{module.blurb}</p>
      {module.gated && (
        <div className="text-[12.5px] text-mut2 leading-[1.5] max-w-[660px] border-l-2 border-line2 pl-3">
          Gated — reads the reconciled dbt mart via the A1 local mirror or the S6 in-tenant deploy, not the resolver.
          Built once that data gate opens (the same dependency as the A2 tier-3 charts).
        </div>
      )}
      <p className="font-mono text-[10.5px] tracking-[.04em] text-mut2">
        will read the windowed /resolve · {scope.site} · {scope.cadence} · {scope.periodFrom} → {scope.periodTo}
      </p>
    </div>
  )
}
